<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 09:31:17
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-03-07 15:25:27
-->
<template>
  <div class="job">
    <div class="ui-hearder-bj job-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/job/bj.png')" alt="" srcset="">
      <div class="job-bj-txt container">
        <div class="hearder-bj-title job-bj-title">{{ $t('job.title') }}</div>
        <div class="hearder-bj-des job-bj-des">{{ $t('job.des') }}</div>
      </div>
    </div>
    <div class="job-content">
      <div class="job-info">
        <div class="job-list-title">{{ $t('job.info[0]') }}</div>
        <div class="line"></div>
        <div class="p-t-20">{{ $t('job.info[1]') }}</div>
        <div>{{ $t('job.info[2]') }}</div>
        <div class="fontw">{{ $t('job.info[3]') }}</div>
        <div class="line"></div>
        <div v-html="$t('job.info[4]')"></div>
        <div v-html="$t('job.info[5]')"></div>
        <div class="fontw">{{ $t('job.info[6]') }}</div>
        <div class="line"></div>
        <div>{{ $t('job.info[7]') }}</div>
        <div class="fontw">{{ $t('job.info[8]') }}</div>
        <div>{{ $t('job.info[9]') }}</div>
      </div>
      <div class="job-welfare">
        <div class="job-list-title">{{ $t('job.welfare.title') }}</div>
        <div class="job-list-des">{{ $t('job.welfare.des') }}</div>
        <div class="flex align_items_end">
          <template v-for="(item, index) in $t('job.welfare.list')">
            <div v-if="index < 6" class="flex_1 job-welfare-item" :key="index">
              <img :class="index == 1 ? 'm-b-3' : ''" :src="item.img" alt="" srcset="">
              <div>{{ item.title }}</div>
            </div>
          </template>
        </div>
        <div class="flex align_items_end">
          <template v-for="(item, index) in $t('job.welfare.list')">
            <div v-if="index >= 6" class="flex_1 job-welfare-item" :key="index">
              <img :src="item.img" alt="" srcset="">
              <div>{{ item.title }}</div>
            </div>
          </template>
        </div>
      </div>
      <div class="job-recruit">
        <div class="job-list-title">{{ $t('job.recruit.title') }}</div>
        <!-- <div class="job-list-des">{{ $t('job.recruit.des') }}</div> -->
        <!-- <div class="job-recruit-box flex flex_wrap">
          <div :class="['job-recruit-item', item.pending ? 'pending' : '']" v-for="(item, index) in $t('job.recruit.list')" :key="item.id">
            <div v-if="item.pending || item.hot" class="hot">{{item.pending ? $t('job.recruit.pending') : $t('job.recruit.hot')}}</div>
            <div class="box center_left_right">
              <div class="title">{{ item.title }} <br />{{ item.des }}</div>
              <div>{{ $t('job.recruit.num') }}： {{ item.num }}</div>
              <div>{{ $t('job.recruit.address') }}： {{ item.address }}</div>
              <div>{{ $t('job.recruit.experience') }}： {{ item.experience }}</div>
              <div>{{ $t('job.recruit.education') }}： {{ item.education }}</div>
              <div class="job-recruit-item-btn" @click="clickLick(index, item.pending)">{{ $t('job.recruit.listMore') }}</div>
            </div>
          </div>
        </div> -->
        <div class="textc">
          <a class="btn job-recruit-btn" :href="$t('job.recruit.boss')" target="_blank">{{ $t('job.recruit.more') }} >></a>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      class="job-dialog"
      width="960px">
      <div>{{ $t('job.recruit.jobDetails') }}</div>
      <div class="position-title">{{ $t(`job.recruit.list[${active}].title`) }}{{ $t(`job.recruit.list[${active}].des`) }}</div>
      <div class="flex job-dialog-item">
        <div class="flex_1">{{ $t('job.recruit.address') }}：{{ $t(`job.recruit.list[${active}].address`)}}</div>
        <div class="flex_1">{{ $t('job.recruit.jobType') }}：{{ $t(`job.recruit.list[${active}].type`)}}</div>
        <div class="flex_1">{{ $t('job.recruit.num') }}：{{ $t(`job.recruit.list[${active}].num`)}}</div>
        <div class="flex_2">{{ $t('job.recruit.updateTime') }}：{{ $t(`job.recruit.list[${active}].time`)}}</div>
      </div>
      <div class="job-dialog-main">
        <div class="title">{{ $t('job.recruit.content') }}：</div>
        <div v-for="(item, index) in $t(`job.recruit.list[${active}].content`)" :key="`1_${index}`">{{index + 1}}、{{item}}</div>
        <div class="title">{{ $t('job.recruit.jobRequirements') }}：</div>
        <div v-for="(item, index) in $t(`job.recruit.list[${active}].requirement`)" :key="`2_${index}`">{{index + 1}}、{{item}}</div>
      </div>
      <div class="textc">
        <a class="btn ilblk" :href="$t('job.recruit.boss')" target="_blank">{{ $t('job.recruit.apply') }}</a>
        <a class="btn active ilblk m-l-46" :href="$t('job.recruit.boss')" target="_blank">{{ $t('job.recruit.collect') }}</a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'job',
  data () {
    return {
      dialogVisible: false,
      active: 0
    }
  },
  methods: {
    clickLick (index, flag) {
      if (!flag) {
        this.active = index
        this.dialogVisible = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pc .job {
  color: #333333;
  .job-bj {
    .job-bj-txt {
      position: absolute;
      right: 0;
      bottom: 90PX;
    }
  }
  .job-content {
    padding: 20PX 0;
    width: 960PX;
    margin: 0 auto;
    font-size: 16PX;
    text-align: center;
    .job-list-title {
      font-size: 40PX;
      font-weight: bold;
      line-height: 60PX;
    }
    .job-list-des {
      line-height: 50PX;
      opacity: 0.6;
    }
    .job-info {
      padding: 20PX 0 112PX 0;
      line-height: 50PX;
      .line {
        width: 36PX;
        height: 1PX;
        background: #00A0E9;
        margin: 0 auto;
        margin-top: 20PX;
        margin-bottom: 10PX;
      }
    }
    .job-welfare {
      padding-bottom: 60PX;
      .job-welfare-item {
        line-height: 22PX;
        padding: 40PX 0;
        img {
          margin-bottom: 20PX;
          // max-width: 75PX;
        }
      }
    }
    .job-recruit {
      .job-recruit-box {
        padding-top: 50PX;
        .job-recruit-item {
          background: #858E91;
          padding-top: 50PX;
          width: calc( 100% / 3 - 22PX);
          height: 400PX;
          color: #E2E2E2;
          font-size: 14PX;
          line-height: 30PX;
          margin-bottom: 30PX;
          border-radius: 11PX;
          cursor: pointer;
          text-align: left;
          position: relative;
          overflow: hidden;
          &:nth-child(3n + 2) {
            margin: 0 32PX;
          }
          &.pending {
            .hot {
              background: rgba(0, 0, 0, 0.1);
              &::before {
                border-right-color: rgba(0, 0, 0, 0.1);
              }
            }
            .job-recruit-item-btn {
              border: 1PX solid rgba(226, 226, 226, 0.5);
              color: rgba(226, 226, 226, 0.5);
            }
          }
          .hot {
            position: absolute;
            top: 0;
            right: 0;
            width: 5em;
            height: 32PX;
            line-height: 32PX;
            color: #ffffff;
            background: rgba(0, 0, 0, 0.2);
            padding-left: 0.8em;
            &::before {
              content: '';
              position: absolute;
              border-bottom: 32PX transparent dashed;
              border-right: 16PX rgba(0, 0, 0, 0.2) solid;
              left: -16PX;
              top: 0;
              z-index: 2;
            }
          }
          .box {
            width: 200PX;
          }
          .title {
            font-size: 32PX;
            line-height: 45PX;
            color: #ffffff;
            padding-bottom: 20PX;
          }
          .job-recruit-item-btn {
            width: 100%;
            height: 40PX;
            border: 1PX solid #E2E2E2;
            line-height: 38PX;
            text-align: center;
            margin-top: 30PX;
          }
          &:hover:not(.pending) {
            background: #00A0E9;
            box-shadow: 0PX 8PX 10PX 0PX rgba(0, 134, 192, 0.28);
            .hot {
              background: rgba(255, 255, 255, 0.2);
              &::before {
                border-right-color: rgba(255, 255, 255, 0.2);
              }
            }
          }
          &:hover.pending {
            cursor: inherit;
          }
        }
      }
      .job-recruit-btn {
        background: #00A0E9;
        color: #ffffff;
        line-height: 52PX;
        padding: 0 40PX;
        display: inline-block;
        margin: 30PX 0;
        font-size: 22PX;
        font-weight: bold;
      }
    }
  }
}
</style>
<style lang="less">
.pc .job {
  .job-dialog {
    .el-dialog {
      border-radius: 8PX;
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 42PX 46PX 40PX 60PX;
    }
    .position-title {
      font-size: 24PX;
      line-height: 33PX;
      padding: 14PX 0 7PX 0;
    }
    .job-dialog-item {
      border-bottom: 1PX solid rgba(151, 151, 151, 0.2);
      padding-bottom: 25PX;
    }
    .job-dialog-main {
      line-height: 22PX;
      font-size: 14PX;
      .title {
        font-size: 16PX;
        padding: 15PX 0;
      }
    }
    .btn {
      width: 145PX;
      line-height: 45PX;
      background: #00A0E9;
      border-radius: 23PX;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
      margin-top: 56PX;
      &.active {
        background: #0054A9;
      }
    }
  }
}
</style>
